import SectionHead from '@/components/general/SectionHead';
import React, { ReactNode } from 'react';
import styles from '../../styles.module.css';

export default function ServiceSectionHead({
  title,
  text,
  children,
}: {
  title?: string;
  text?: string;
  children?: ReactNode;
}) {
  return (
    <SectionHead
      headingTag="h2"
      title={title}
      text={text}
      titleClass={`${styles.heading} ${text && styles.smallMargin}`}
      textTitle={`${styles.headText}`}
      wrapper={`${styles.serviceHead}`}
    >
      {children}
    </SectionHead>
  );
}
